<template>
    <div>
        <v-form v-model="formValid" ref="form">
            <form-field :field="nameField" star v-if="name.check" v-model="nameField.value" />
            <form-field :field="mailField" star v-if="mail.check" v-model="mailField.value" />
            <form-field :field="phoneField" star v-if="phone.check" v-model="phoneField.value" />
            <form-field :field="messageField" star v-if="message.check" v-model="messageField.value" />
        </v-form>

        <div class="d-flex">
            <v-spacer />
            <zoezi-button :text="$translate(buttonText)" @click="send" :disabled="!formValid" :loading="loading" />
        </div>

        <v-dialog v-model="showDialog" max-width="500">
            <v-card>
                <v-card-title class="headline" v-text="$translate(doneTitle)" />
                <v-card-text v-text="$translate(doneText)" />

                <v-card-actions>
                    <v-spacer></v-spacer>

                    <zoezi-button :text="$translate('Ok')" @click="showDialog = false" />
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import FormField from "../components/FormField.vue"

export default {
    name: 'zoezi-contact-form',

    components: {
        FormField
    },

    zoezi: {
        title: 'Contact form',
        icon: 'mdi-email'
    },

    props: {
        name: {
            title: 'Name',
            type: Object,
            fulltype: 'checktoggle',
            typeinfo: {
                header: ['Include field', 'Required']
            },
            default: () => ({check: true, toggle: true})
        },
        mail: {
            title: 'E-mail',
            type: Object,
            fulltype: 'checktoggle',
            default: () => ({check: true, toggle: true})
        },
        phone: {
            title: 'Phone',
            type: Object,
            fulltype: 'checktoggle',
            default: () => ({check: false, toggle: true})
        },
        message: {
            title: 'Message',
            type: Object,
            fulltype: 'checktoggle',
            default: () => ({check: true, toggle: true})
        },
        receivers: {
            title: 'Recipient',
            type: Array,
            fulltype: 'select',
            typeinfo: {
                multiple: true,
                text: 'name',
                value: 'id',
                placeholder: 'Select staff',
                nosort: true,
                getItems: () => window.$zoeziapi.get('/api/member/get/full').then(members => members.filter(member => member.staff).map(x => ({id: x.id, name: x.firstname ? x.firstname + ' ' + x.lastname : x.lastname})))
            },
            default: () => []
        },
        buttonText: {
            title: 'Button text',
            type: String,
            default: 'Send'
        },
        doneTitle: {
            title: 'Reply header',
            type: String,
            default: 'Message sent'
        },
        doneText: {
            default: 'Thank you for your message!'
        }
    },

    watch: {
        name: {
            immediate: true,
            handler(f) {
                this.nameField.required = f.toggle;
            }
        },
        mail: {
            immediate: true,
            handler(f) {
                this.mailField.required = f.toggle;
            }
        },
        phone: {
            immediate: true,
            handler(f) {
                this.phoneField.required = f.toggle;
            }
        },
        message: {
            immediate: true,
            handler(f) {
                this.messageField.required = f.toggle;
            }
        }
    },

    data: () => ({
        nameField: {type: 'text', title: 'First & last name', icon: 'mdi-account', required: true, value: ''},
        mailField: {type: 'email', title: 'E-mail', icon: 'mdi-email', required: true, value: ''},
        phoneField: {type: 'phone', title: 'Mobile phone number', icon: 'mdi-cellphone-iphone', required: true, value: ''},
        messageField: {type: 'textarea', title: 'Message', icon: 'mdi-message', required: true, value: ''},
        formValid: false,
        showDialog: false,
        loading: false
    }),

    methods: {
        send() {
            if (!this.formValid) {
                return;
            }

            this.loading = true;
            let data = {
                homepage_revision_id: this.$root.published_revision_id,
                receivers: this.receivers
            }
            if (this.name.check) data.name = this.nameField.value;
            if (this.mail.check) data.mail = this.mailField.value;
            if (this.phone.check) data.phone = this.phoneField.value;
            if (this.message.check) data.message = this.messageField.value;
            this.$api.post('/api/public/contactform/send', data).then((response) => {
                if (response.ok) {
                    this.nameField.value = '';
                    this.mailField.value = '';
                    this.phoneField.value = '';
                    this.messageField.value = '';
                    this.$refs.form.reset()
                    this.showDialog = true;
                } else {
                    this.$store.commit('showErrorDialog', {title: this.$translate('Error'), text: this.$translate('Unfortunately, the message could not be sent')})
                }
                this.loading = false;
            });
        }
    }
}
</script>
